
import axios, { AxiosResponse } from "axios";
import { Component, Vue } from "vue-property-decorator";
import GlobalConfig from "@/GlobalConfig";
import UmbracoApiService from "@/services/UmbracoApiService";
import WsdlService from "@/services/WsdlService";
import FundTypeObj from "@/models/WsdlResponses/FundTypeObj";
import Swal from "sweetalert2";
import ServicioNotificacionBalanceModel, {
    UserBalanceModel,
} from "@/models/ServicioNotificacionBalance/ServicioNotificacionBalanceModel";
import NotificationBalanceForm from "@/components/Notificacion_Balance/NotificacionBalanceForm.vue";
import NotificationBalanceResult from "@/components/Notificacion_Balance/NotificacionBalanceResult.vue";
import NotificationBalanceResponse from "@/components/Notificacion_Balance/NotificacionBalanceResponse.vue";
import SolicitudNotificacionBalanceModel from "@/models/SolicitudNotificacionBalance/SolicitudNotificacionBalanceModel";

@Component({
	components: {
		NotificationBalanceForm, 
		NotificationBalanceResult,
		NotificationBalanceResponse
	}
})
export default class NotificationBalance extends Vue {
	public step: number = 1;
    public tipoFondo: FundTypeObj = new FundTypeObj();
    public checkProcesar: boolean = false;
    public userId: string = this.$store.state.user.cedula;
    public wsdlService: WsdlService = new WsdlService();
	public umbracoService = new UmbracoApiService();
    public userBalaceModel = new UserBalanceModel();
	public isEmailActive: boolean = false;
	public isCelActive: boolean = false;
    public test: any[] = [];
	public umbracoBaseUrl: string = GlobalConfig.UMBRACO_BASE_URL;

    public labelData = new SolicitudNotificacionBalanceModel();

    constructor() {
        super();
    }
	async getAllData() {
        this.labelData =
            await this.umbracoService.getSolicitudNotificacionBalance();
	}
    async getDropdownData() {
        this.wsdlService
            .getTipoDeFondos(this.userId, "")
            .then((response: AxiosResponse<FundTypeObj>) => {
                this.tipoFondo = response.data;

            });
    }
	public nextStep(){
		if(this.tipoFondo.tipofondos.emailusuario)
			{
				this.step++;
				return;
			}
			Swal.fire({
				text: "Debes tener tu e-mail registrado para recibir notificaciones por esta vía.",
				icon: "info",
				showConfirmButton: true,
				showCancelButton: true,
				confirmButtonText: "Actualizar Datos",
				cancelButtonText: "Cancelar"
			}).then((result) => {
					if (result.value) {
						this.updateUser();
					}
				}); 
	}
	public updateNotificationData(isEmailActive: boolean, isCelActive: boolean){
		this.isEmailActive = isEmailActive;
		this.isCelActive = isCelActive;
	}
    procesar() {
        if (!this.checkProcesar)
		{
			Swal.fire({
				text: "Debe Elegir \"Si Acepto\" para procesar su solicitud",
				icon: "error",
				showConfirmButton: true,
				confirmButtonText: "Ok",
				onClose: () => {
					
				}
			});
		}
		else{
			if(this.tipoFondo.tipofondos.emailusuario)
			{
				this.step++;
				return;
			}
			Swal.fire({
				text: "Debes tener tu e-mail registrado para recibir notificaciones por esta vía.",
				icon: "info",
				showConfirmButton: true,
				showCancelButton: true,
				confirmButtonText: "Actualizar Datos",
				cancelButtonText: "Cancelar"
			}).then((result) => {
					if (result.value) {
						this.updateUser();
					}
				}); 
		}
    }
	returnHome(){
		window.location.href = GlobalConfig.PORTAL_BASE_URL
	}

    async mounted() {
		await this.getAllData();
        await this.getDropdownData();
    }
	updateUser(){
		this.$router.push('actualizacion-de-datos');
	}
}
